import { Fragment, type ReactNode } from "react";

export default function MeetWrapper({ children }: { children: ReactNode }) {
  return <Fragment>{children}</Fragment>;
}
